import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Compose from "../pages/compose/page";
import Composer from "../pages/composer/page";
import Landing from "../pages/landing/page";
import OutcomePage from "../pages/landing/OutcomePage";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import AuthCallback from "../pages/auth/Callback";
import Dashboard from "../pages/dashboard/page";
import PlaybooksPage from "../pages/playbooks/page";
import Admin from "../pages/admin/page";
import Marketplace from "../pages/marketplace/page";
import PlaybookDetail from "../pages/marketplace/detail";
import { RedirectAccount, RedirectNewProject, RedirectProjects } from "../pages/dashboard/redirects";
import Privacy from "../pages/legal/Privacy";
import Terms from "../pages/legal/Terms";

const routes: RouteObject[] = [
  { path: "/", element: <Landing /> },
  { path: "/outcomes/:id", element: <OutcomePage /> },
  { path: "/studio", element: <Home /> },
  { path: "/compose", element: <Compose /> },
  { path: "/composer", element: <Composer /> },
  { path: "/login", element: <Login /> },
  { path: "/register", element: <Register /> },
  { path: "/auth/callback", element: <AuthCallback /> },
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/marketplace", element: <Marketplace /> },
  { path: "/marketplace/:id", element: <PlaybookDetail /> },
  { path: "/playbooks", element: <PlaybooksPage /> },
  { path: "/admin", element: <Admin /> },
  { path: "/account", element: <RedirectAccount /> },
  { path: "/projects", element: <RedirectProjects /> },
  { path: "/projects/new", element: <RedirectNewProject /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/terms-of-use", element: <Terms /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
